
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";
import "../../App.css";
import logo from "../../images/SPFLLOGO.png"; 

import ExcelExport from "../../UserControls/ExcelExport/ExcelExport";
 

const TicketList = () => {
  const [tickets, setTickets] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewMode, setViewMode] = useState("table"); 
  const navigate = useNavigate();
  const userName = sessionStorage.getItem("userName");
  const companyName = sessionStorage.getItem("companyName");

  // ✅ Fetch tickets on mount
  useEffect(() => {
    const fetchTickets = async () => {
      try {
        setLoading(true);
        const data = await api.GetTicketList(userName);
        if (data && data.Table) {
          const sorted = [...data.Table].sort((a, b) => b.TicketId - a.TicketId);
          setTickets(sorted);
          setFilteredTickets(sorted);
        } else {
          setError("Unexpected API response");
        }
      } catch (err) {
        console.error("Error fetching tickets:", err);
        setError("Failed to fetch tickets. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchTickets();
  }, [userName]);

  // ✅ Search Filter
  useEffect(() => {
    const filtered = tickets.filter((t) =>
      Object.values(t).some(
        (val) =>
          val &&
          val.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
    setFilteredTickets(filtered);
  }, [searchTerm, tickets]);

  // ✅ Export filtered tickets to Excel
  
  
  if (loading) {
    return <div className="loading">Loading tickets...</div>;
  }

  if (error) {
    return (
      <div className="error">
        {error}{" "}
        <button onClick={() => window.location.reload()} className="btn-retry">
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="ticket-container" style={{ width: "95%", margin: "0 auto" }}>
       {/* 🧩 Header Styling: Added to ensure correct layout and prevent issues with external CSS */}
       <style>{`
        /* Container for the logo/company name and the page title */
        .header-controls {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 20px;
            background: #fff;
            padding: 15px 20px;
            border-radius: 10px;
            box-shadow: 0 2px 6px rgba(0,0,0,0.1);
            position: relative; /* Allows logo-and-name to be positioned absolutely */
        }

        /* Div to hold logo and company name in a single row */
        .logo-and-name {
            display: flex;
            align-items: center;
            position: absolute;
            left: 20px;
            top: 50%;
            transform: translateY(-50%);
        }

        .logo-and-name img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background-color: white;
            box-shadow: 0 0 4px rgba(0,0,0,0.2);
            padding: 5px;
            margin-right: 1px;
            object-fit: contain;
        }

        .logo-and-name h1 {
            font-size: 22px;
            font-weight: bold;
            color: #333;
            margin: 0;
            text-align: left;
        }
        
        /* Ensures the title is centered */
        .page-title {
            text-align: center;
            font-size: 1.4rem;
            font-weight: 500;
            color: #1f2937;
            margin: 0;
        }

        /* 📱 Mobile & Tablet Responsive Enhancements */
@media (max-width: 1024px) {
  .header-controls {
    flex-direction: column;
    text-align: center;
    padding: 10px;
  }

  .logo-and-name {
    position: relative;
    left: 0;
    top: 0;
    transform: none;
    justify-content: center;
    margin-bottom: 8px;
  }

  .logo-and-name img {
    width: 45px;
    height: 45px;
    margin-right: 6px;
  }

  .logo-and-name h1 {
    font-size: 18px;
  }

  .page-title {
    font-size: 1.2rem;
  }

  .top-controls {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .top-right-controls {
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }

  .search-box {
    width: 100%;
    max-width: 300px;
  }

  .search-input {
    width: 100%;
  }

  .view-icons {
    display: flex;
    justify-content: center;
  }

  .grid-cards {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 10px;
  }

  .asset-card {
    width: 100%;
  }

  .table-wrapper {
    overflow-x: auto;
  }

  .asset-table {
    min-width: 700px;
  }

  .btn-primary,
  .btn-edit,
  .btn-edit-small {
    font-size: 0.9rem;
    padding: 6px 10px;
  }
}

@media (max-width: 480px) {
  .logo-and-name img {
    width: 40px;
    height: 40px;
  }

  .logo-and-name h1 {
    font-size: 16px;
  }

  .page-title {
    font-size: 1rem;
  }

  .btn-primary {
    width: 100%;
  }

  .asset-card h3 {
    font-size: 1rem;
  }

  .asset-card p {
    font-size: 0.85rem;
  }

  .view-icons button {
    padding: 4px;
  }
}


      `}</style>
      
      {/* ✅ NEW Header structure: Logo and Company Name in a single div */}
      <div className="header-controls">
        <div className="logo-and-name">
          {/* <img src={logo} alt="Company Logo" /> */}
          <h1>{companyName}</h1>
        </div>
        <h2 className="page-title">Ticket List</h2>
      </div>
      {/* ✅ Top Controls */}
      <div className="top-controls">
        <button
          className="btn-primary"
          onClick={() => navigate("/TicketForm")}
        >
          ➕ New
        </button>

        <div className="top-right-controls">
          {/* 🔍 Search Box */}
          <div className="search-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="search-icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"
              />
            </svg>
            <input
              type="text"
              placeholder="Search tickets..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>

  
    <ExcelExport data={filteredTickets} fileName="TicketList" />
           
          {/* 🧩 View Mode Toggle */}
          <div className="view-icons">
            <button
              onClick={() => setViewMode("card")}
              className={`icon-btn ${viewMode === "card" ? "active" : ""}`}
              title="Card View"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon-svg"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z" />
              </svg>
            </button>

            <button
              onClick={() => setViewMode("table")}
              className={`icon-btn ${viewMode === "table" ? "active" : ""}`}
              title="Table View"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon-svg"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M4 6h16v2H4V6zm0 4h16v2H4v-2zm0 4h16v2H4v-2zm0 4h16v2H4v-2z" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* ✅ Card View (Updated like Asset Register) */}
      {viewMode === "card" ? (
        <div className="grid-cards">
          {filteredTickets.map((t) => (
            <div key={t.TicketId} className="asset-card">
              <h3>{t.TicketNo}</h3>
              <p>
                <strong>Asset:</strong> {t.AssetName}
              </p>
              <p>
                <strong>IssueTitle:</strong> {t.IssueTitle}
              </p>
              <p>
                <strong>Dept:</strong> {t.DeptName}
              </p>
              <p>
                <strong>Raised By:</strong> {t.RaisedBy}
              </p>
              <p>
                <strong>Priority:</strong> {t.Priority}
              </p>
              {/* Status color indicator */}
              {t.Status && (
                <p>
                  <strong>Status:</strong>{" "}
                  <span
                    style={{
                      color:
                        t.Status === "Open"
                          ? "red"
                          : t.Status === "In Progress"
                          ? "orange"
                          : "green",
                      fontWeight: "bold",
                    }}
                  >
                    {t.Status}
                  </span>
                </p>
              )}
              <button
                className="btn-edit"
                onClick={() => navigate(`/TicketForm/${t.TicketId}`)}
              >
                ✏️ Edit
              </button>
            </div>
          ))}
          {filteredTickets.length === 0 && (
            <p className="mt-4 text-center text-gray-500">No tickets found.</p>
          )}
        </div>
      ) : (
        // ✅ Table View (unchanged)
        <div className="table-wrapper" >
          <table className="asset-table">
            <thead>
              <tr>
                <th style={{ width: "10%" }}>Ticket No</th>
                <th style={{ width: "20%" }}>Issue Title</th>
                <th style={{ width: "18%" }}>Asset Name</th>
                <th style={{ width: "15%" }}>Dept Name</th>
                <th style={{ width: "15%" }}>Raised By</th>
                <th style={{ width: "10%" }}>Priority</th>
                <th style={{ width: "12%" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredTickets.map((t) => (
                <tr key={t.TicketId}>
                  <td>{t.TicketNo}</td>
                  <td>{t.IssueTitle}</td>
                  <td>{t.AssetName}</td>
                  <td>{t.DeptName}</td>
                  <td>{t.RaisedBy}</td>
                  <td>{t.Priority}</td>
                  <td>
                    <button
                      className="btn-edit-small"
                      onClick={() => navigate(`/TicketForm/${t.TicketId}`)}
                    >
                      ✏️ Edit
                    </button>
                  </td>
                </tr>
              ))}
              {filteredTickets.length === 0 && (
                <tr>
                  <td colSpan="7" className="py-4 text-center text-gray-500">
                    No tickets found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TicketList;





// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../../api/api";
// import "../../App.css";
// import logo from "../../images/SPFLLOGO.png"; 

// import ExcelExport from "../../UserControls/ExcelExport/ExcelExport";
 

// const TicketList = () => {
//   const [tickets, setTickets] = useState([]);
//   const [filteredTickets, setFilteredTickets] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [viewMode, setViewMode] = useState("table"); 
//   const navigate = useNavigate();
//   const userName = sessionStorage.getItem("userName");
//   const companyName = sessionStorage.getItem("companyName");

//   // ✅ Fetch tickets on mount
//   useEffect(() => {
//     const fetchTickets = async () => {
//       try {
//         setLoading(true);
//         const data = await api.GetTicketList(userName);
//         if (data && data.Table) {
//           const sorted = [...data.Table].sort((a, b) => b.TicketId - a.TicketId);
//           setTickets(sorted);
//           setFilteredTickets(sorted);
//         } else {
//           setError("Unexpected API response");
//         }
//       } catch (err) {
//         console.error("Error fetching tickets:", err);
//         setError("Failed to fetch tickets. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTickets();
//   }, [userName]);

//   // ✅ Search Filter
//   useEffect(() => {
//     const filtered = tickets.filter((t) =>
//       Object.values(t).some(
//         (val) =>
//           val &&
//           val.toString().toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     );
//     setFilteredTickets(filtered);
//   }, [searchTerm, tickets]);

//   // ✅ Export filtered tickets to Excel
  
  
//   if (loading) {
//     return <div className="loading">Loading tickets...</div>;
//   }

//   if (error) {
//     return (
//       <div className="error">
//         {error}{" "}
//         <button onClick={() => window.location.reload()} className="btn-retry">
//           Retry
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="ticket-container" style={{ width: "95%", margin: "0 auto" }}>
//        {/* 🧩 Header Styling: Added to ensure correct layout and prevent issues with external CSS */}
//        <style>{`
//         /* Container for the logo/company name and the page title */
//         .header-controls {
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             margin-bottom: 20px;
//             background: #fff;
//             padding: 15px 20px;
//             border-radius: 10px;
//             box-shadow: 0 2px 6px rgba(0,0,0,0.1);
//             position: relative; /* Allows logo-and-name to be positioned absolutely */
//         }

//         /* Div to hold logo and company name in a single row */
//         .logo-and-name {
//             display: flex;
//             align-items: center;
//             position: absolute;
//             left: 20px;
//             top: 50%;
//             transform: translateY(-50%);
//         }

//         .logo-and-name img {
//             width: 60px;
//             height: 60px;
//             border-radius: 50%;
//             background-color: white;
//             box-shadow: 0 0 4px rgba(0,0,0,0.2);
//             padding: 5px;
//             margin-right: 1px;
//             object-fit: contain;
//         }

//         .logo-and-name h1 {
//             font-size: 22px;
//             font-weight: bold;
//             color: #333;
//             margin: 0;
//             text-align: left;
//         }
        
//         /* Ensures the title is centered */
//         .page-title {
//             text-align: center;
//             font-size: 1.4rem;
//             font-weight: 500;
//             color: #1f2937;
//             margin: 0;
//         }
//       `}</style>
      
//       {/* ✅ NEW Header structure: Logo and Company Name in a single div */}
//       <div className="header-controls">
//         <div className="logo-and-name">
//           <img src={logo} alt="Company Logo" />
//           <h1>{companyName}</h1>
//         </div>
//         <h2 className="page-title">Ticket List</h2>
//       </div>
//       {/* ✅ Top Controls */}
//       <div className="top-controls">
//         <button
//           className="btn-primary"
//           onClick={() => navigate("/TicketForm")}
//         >
//           ➕ New
//         </button>

//         <div className="top-right-controls">
//           {/* 🔍 Search Box */}
//           <div className="search-box">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               className="search-icon"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"
//               />
//             </svg>
//             <input
//               type="text"
//               placeholder="Search tickets..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="search-input"
//             />
//           </div>

  
//     <ExcelExport data={filteredTickets} fileName="TicketList" />
           
//           {/* 🧩 View Mode Toggle */}
//           <div className="view-icons">
//             <button
//               onClick={() => setViewMode("card")}
//               className={`icon-btn ${viewMode === "card" ? "active" : ""}`}
//               title="Card View"
//             >
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="icon-svg"
//                 fill="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z" />
//               </svg>
//             </button>

//             <button
//               onClick={() => setViewMode("table")}
//               className={`icon-btn ${viewMode === "table" ? "active" : ""}`}
//               title="Table View"
//             >
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="icon-svg"
//                 fill="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path d="M4 6h16v2H4V6zm0 4h16v2H4v-2zm0 4h16v2H4v-2zm0 4h16v2H4v-2z" />
//               </svg>
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* ✅ Card View (Updated like Asset Register) */}
//       {viewMode === "card" ? (
//         <div className="grid-cards">
//           {filteredTickets.map((t) => (
//             <div key={t.TicketId} className="asset-card">
//               <h3>{t.TicketNo}</h3>
//               <p>
//                 <strong>Asset:</strong> {t.AssetName}
//               </p>
//               <p>
//                 <strong>IssueTitle:</strong> {t.IssueTitle}
//               </p>
//               <p>
//                 <strong>Dept:</strong> {t.DeptName}
//               </p>
//               <p>
//                 <strong>Raised By:</strong> {t.RaisedBy}
//               </p>
//               <p>
//                 <strong>Priority:</strong> {t.Priority}
//               </p>
//               {/* Status color indicator */}
//               {t.Status && (
//                 <p>
//                   <strong>Status:</strong>{" "}
//                   <span
//                     style={{
//                       color:
//                         t.Status === "Open"
//                           ? "red"
//                           : t.Status === "In Progress"
//                           ? "orange"
//                           : "green",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {t.Status}
//                   </span>
//                 </p>
//               )}
//               <button
//                 className="btn-edit"
//                 onClick={() => navigate(`/TicketForm/${t.TicketId}`)}
//               >
//                 ✏️ Edit
//               </button>
//             </div>
//           ))}
//           {filteredTickets.length === 0 && (
//             <p className="mt-4 text-center text-gray-500">No tickets found.</p>
//           )}
//         </div>
//       ) : (
//         // ✅ Table View (unchanged)
//         <div className="table-wrapper" >
//           <table className="asset-table">
//             <thead>
//               <tr>
//                 <th style={{ width: "10%" }}>Ticket No</th>
//                 <th style={{ width: "20%" }}>Issue Title</th>
//                 <th style={{ width: "18%" }}>Asset Name</th>
//                 <th style={{ width: "15%" }}>Dept Name</th>
//                 <th style={{ width: "15%" }}>Raised By</th>
//                 <th style={{ width: "10%" }}>Priority</th>
//                 <th style={{ width: "12%" }}>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredTickets.map((t) => (
//                 <tr key={t.TicketId}>
//                   <td>{t.TicketNo}</td>
//                   <td>{t.IssueTitle}</td>
//                   <td>{t.AssetName}</td>
//                   <td>{t.DeptName}</td>
//                   <td>{t.RaisedBy}</td>
//                   <td>{t.Priority}</td>
//                   <td>
//                     <button
//                       className="btn-edit-small"
//                       onClick={() => navigate(`/TicketForm/${t.TicketId}`)}
//                     >
//                       ✏️ Edit
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//               {filteredTickets.length === 0 && (
//                 <tr>
//                   <td colSpan="7" className="py-4 text-center text-gray-500">
//                     No tickets found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TicketList;


